module.exports = window["redfoxThankYou"]["components"];